import React, { useMemo } from 'react';
import useSelectCompanyPairedWithDirectDebit, { ICompanyPairedResponse } from './useSelectCompanyPairedWithDirectDebit';

import { SelectProps } from 'antd';
import { SelectBankWrapper } from '../LightningBank/lightningBankStyle';
import { CONST_CREATE_COMPANY } from 'constants/language';
import { IDirectDebitSubCompany } from 'constants/operatorSite';

interface ISelectCompanyPairedWithDirectDebit extends SelectProps {
  width?: number;
  height?: number;
  margin?: number[];
  onChangeCompanyPairedWithDirectDebit: (code: string, company_name: string) => void;
  value: string | undefined;
  company?: IDirectDebitSubCompany | undefined;
  // listCompanyPairedInit?: ICompanyPairedResponse[] | any;
}
const SelectCompanyPairedWithDirectDebit = ({ width, height, margin, onChangeCompanyPairedWithDirectDebit, value, company, ...props }: ISelectCompanyPairedWithDirectDebit) => {
  const { listCompanyPaired, isLoading } = useSelectCompanyPairedWithDirectDebit();

  const companyPairedOptions = useMemo(() => {
    const baseOptions = listCompanyPaired ?? [];
    if (value && !baseOptions.find((option: ICompanyPairedResponse) => option.code === value)) {
      const currentOption = {
        code: value,
        name: company?.name,
        id: company?.id,
        label: `${company?.name} ${value}`,
        value: value
      };
      return [currentOption, ...baseOptions];
    }

    return baseOptions;
  }, [listCompanyPaired, value, company]);

  const marginCustom = margin
    ? `${margin[0] || 0}rem ${margin[1] || 0}rem ${margin[2] || 0}rem ${margin[3] || 0}rem`
    : '0rem';
  return (
    <SelectBankWrapper
      {...props}
      showSearch
      value={!isLoading ? value : ''}
      custom={{ width: 16, height: height || 2.5, margin: marginCustom }}
      placeholder=''
      optionFilterProp="children"
      onChange={(e: string) => {
        const companyPaired = companyPairedOptions.find((element: ICompanyPairedResponse) => element.code === e);
        onChangeCompanyPairedWithDirectDebit(e, companyPaired?.name);
      }}
      filterOption={(input: any, option: any) => (option?.label ?? '').includes(input.trim())}
      filterSort={(optionA: any, optionB: any) =>
        (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
      }
      options={companyPairedOptions}
    />
  );
};

export default SelectCompanyPairedWithDirectDebit;
